import React, { useState } from "react";
import CONSTANTS from "../../../constants";
import { connect } from "react-redux";
import { CurrentStepSetAction } from "./../../../actions/action";
import chevronOrange from "../../../images/AC/ac_chevron_down_orange.png";
import emailIcon from "../../../images/AC/ac-email-blue.png";
import phoneIcon from "../../../images/AC/ac-phone-blue.png";
import contactMethodIcon from "../../../images/AC/ac-contact-method-blue.png";
import editIcon from "../../../images/AC/ac-edit-summary.png";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import { Link } from "react-router-dom";

const mapStateToProps = (state) => state;
const mapDispatchToProps = { CurrentStepSetAction };

const PersonalInfosSummaryFlex = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { personalInfos } = props.store;
  const civility =
    personalInfos.civilityCode == "Common_Sir"
      ? CONSTANTS.LABELS.userinfos_mister
      : personalInfos.civilityCode == "Common_Madam"
      ? CONSTANTS.LABELS.userinfos_madam
      : CONSTANTS.LABELS.userinfos_neutral;
  const contactMethod = personalInfos.contactMode;
  return (
    <div className="rootPersonalInfosContainer">
      <div className="infosSectionTitleContainer">
        <div className="infosSectionTitle">
          {CONSTANTS.LABELS.summary_userinfos}
        </div>
        <img
          src={chevronOrange}
          className={isOpen ? "chevronDetail isOpen" : "chevronDetail"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div
        className={
          isOpen ? "infosContentContainer isOpen" : "infosContentContainer"
        }
      >
        <div className="fullName">
          {civility} {personalInfos.firstname} {personalInfos.name}
        </div>
        <div className="infosBodyContainer">
          <div className="separatorInfos"></div>
          <div className="personalInfosContainer">

          {/* emTelHolder = email telephone holder */}
            <div className="emTelHolder">
            <div className="sectionContainer">
              <div className="sectionTitleIconContainer">
                <img src={emailIcon} />
                <div className="sectionTitle">
                  {CONSTANTS.LABELS.summary_userinfos_email}
                </div>
              </div>
              <div className="valueTitle">{personalInfos.mail}</div>
            </div>

            <div className="sectionContainer">
              <div className="sectionTitleIconContainer">
                <img src={phoneIcon} />
                <div className="sectionTitle">
                  {CONSTANTS.LABELS.summary_userinfos_tel}
                </div>
              </div>
              <div className="valueTitle">{personalInfos.phone}</div>
            </div>
            </div>

            <div className="sectionContainer">
              <div className="sectionTitleIconContainer">
                <img src={contactMethodIcon} />
                <div className="sectionTitle">
                  {CONSTANTS.LABELS.summary_userinfos_contact_mode}
                </div>
              </div>
              <div className="valueTitle">{contactMethod}</div>
            </div>
          </div>

          {(!props.store.isEditMode ||
            (props.store.isEditMode && !props.expiredDate)) && (
            <Link
              to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
              onClick={(e) => {
                pushEventToGTM({
                  pageName: "summary",
                  eventAction: "Redirection::Internal::Modify",
                  eventLabel: "summary_modify_perso_data",
                });
                props.CurrentStepSetAction(5);
              }}
            >
              <div className="editButton">
                <img src={editIcon} />
                <div className="editButtonTitle">
                  {CONSTANTS.LABELS.common_v2_modify}
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalInfosSummaryFlex);
